import React from 'react';

const EMOJIS = [
  '😀','😃','😄','😁','😆','😅','😂','🤣','😊','😇',
  '🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚',
  '😋','😜','😝','😛','🤑','🤗','🤩','🤔','🤨','😐',
  '😑','😶','🙄','😏','😣','😥','😮','🤐','😯','😪',
  '😫','🥱','😴','😌','😛','😜','😝','🤤','😒','😓',
  '😔','😕','🙃','🤑','😲','☹️','🙁','😖','😞','😟',
  '😤','😢','😭','😦','😧','😨','😩','🤯','😬','😰',
  '😱','🥵','🥶','😳','🤪','😵','😡','😠','🤬','😷',
  '🤒','🤕','🤢','🤮','🥴','😇','🥳','🥺','🤠','🤡',
  '🤥','🤫','🤭','🧐','🤓','😈','👿','👹','👺','💀',
  '👻','👽','🤖','💩','😺','😸','😹','😻','😼','😽',
  '🙀','😿','😾','🐶','🐱','🐭','🐹','🐰','🦊','🐻',
  '🐼','🐨','🐯','🦁','🐮','🐷','🐽','🐸','🐵','🙈',
  '🙉','🙊','🐒','🐔','🐧','🐦','🐤','🐣','🐥','🦆',
  '🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋',
  '🐌','🐞','🐜','🦟','🦗','🕷','🕸','🦂','🐢','🐍',
  '🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠',
  '🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍',
  '🦧','🐘','🦛','🦏','🐪','🐫','🦒','🐃','🐂','🐄',
  '🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕','🐩','🦮',
  '🐕‍🦺','🐈','🐓','🦃','🦚','🦜','🦢','🦩','🕊','🐇',
  '🐁','🐀','🐿','🦔'
];

function EmojiPickerWidget({ x = 0, y = 0, onEmojiSelect, style = {} }) {
  const numAcross = 10;

  const handleEmojiClick = (emoji) => {
    if (onEmojiSelect) {
      onEmojiSelect(emoji);
    }
  };

  const containerStyle = {
    position: 'absolute',
    left: x,
    top: y,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e5e7eb',
    padding: '8px',
    zIndex: 100,
    ...style
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${numAcross}, 1fr)`,
    gap: '4px',
    width: '300px',
    maxHeight: '280px',
    overflowY: 'auto',
  };

  const emojiStyle = {
    width: '24px',
    height: '24px',
    fontSize: '20px',
    cursor: 'pointer',
    textAlign: 'center',
    borderRadius: '4px',
    transition: 'background 0.2s',
  };

  return (
    <div style={containerStyle}>
      <div style={gridStyle}>
        {EMOJIS.map((emoji, index) => (
          <div
            key={index}
            style={emojiStyle}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleEmojiClick(emoji);
            }}
            title={emoji}
          >
            {emoji}
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmojiPickerWidget;
